// IMPORTS
// Modules
import { useState } from 'react';
// OHS
import { OHSListDataFormatter } from '../../../../../onehivesystems/js/OHSList';
import { OHSFormItem, OHSFormSubmit, OHSFormSubmitListener, OHSFormDataExtractor, OHSFormDataClearer } from '../../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../../onehivesystems/js/OHSCRUD';
// Assets
import { collectionModel } from './../_variables';


// COMPONENT
export default function Collection (props) {
   // States and Variables
   const [changePassword, setChangePassword] = useState(false);

   // Functions
   const updateCollection = function () {
      OHSCRUD({
         url: '/v1/oneport/collections/' + props.content.id.value,
         method: 'PUT',
         payload: OHSFormDataExtractor('oneport-collection'),
         success: function (data) {
            var temp = props.parent.collections;
            temp[props.index] = OHSListDataFormatter(data[0], collectionModel);
            props.parent.setCollections(temp)
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }
   const deleteCollection = function () {
      OHSCRUD({
         url: '/v1/oneport/collections/' + props.content.id.value,
         method: 'DELETE',
         success: function () {
            props.hidePopup(props.index);
            var temp = props.parent.collections;
            temp.splice(props.index, 1);
            props.parent.setCollections(temp);
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         setOHSConfirmation: props.onehive.setConfirmation,
         confirmMessage: "Are you sure you wish to delete this collection?",
         showSuccessPopup: true
      });
   }
   const clearSSHPassword = function () {
      OHSCRUD({
         url: '/v1/oneport/collections/' + props.content.id.value + '/clearsshpassword',
         method: 'PUT',
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         setOHSConfirmation: props.onehive.setConfirmation,
         confirmMessage: "Are you sure you wish to clear this collection's SSH password?",
         showSuccessPopup: true
      });
   }
   const toggleChangePassword = function () {
      setChangePassword(!changePassword);
   }

   // Component
   return (
      <div id='oneport-collection' className='oneport-collection' onKeyDown={(e) => {OHSFormSubmitListener(e, updateCollection);}}>
         <OHSFormItem onehive={props.onehive} title="Name">
            <input type='text' className='ohsinput' defaultValue={props.content.name.value} data-ohsformdata='name' />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="SSH Username">
            <input type='text' className='ohsinput' defaultValue={props.content.ssh_username.value} data-ohsformdata='ssh_username' placeholder='(Optional)' />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="SSH Password">
            {changePassword ? 
               <>
                  <input type='password' className='ohsinput' data-ohsformdata='ssh_password' placeholder='(Optional)' />
                  <button className='ohsbtn-error' onClick={toggleChangePassword}>Cancel</button>
               </>
            :
               <>
                  <button className='ohsbtn' onClick={toggleChangePassword}>Change Password</button>
                  <button className='ohsbtn-error' onClick={clearSSHPassword}>Clear Password</button>
               </>
            }
         </OHSFormItem>
         <OHSFormSubmit onehive={props.onehive} update={updateCollection} clear={() => {OHSFormDataClearer('oneport-collection');}} delete={deleteCollection} keyListener={true} />
      </div>
   );
}